//import { initial } from "lodash";

const initialState = {}

const reducer = (state = initialState, action) => {
    return state;
}

export default reducer;